import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PoCodeEditorModule } from '@po-ui/ng-code-editor';
import { PoModule } from '@po-ui/ng-components';

import { ApiKeysComponent } from './api-keys.component';

@NgModule({
  declarations: [ApiKeysComponent],
  imports: [CommonModule, FormsModule, PoModule, PoCodeEditorModule],
  exports: [ApiKeysComponent]
})
export class ApiKeysModule {}
